/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  CheckBox,
  DropdownBox,
  InputBox,
  SubmitButton,
  TextAreaBox,
  UploadBox,
  DatePicker,
} from "../../components/Input";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { API_URL } from "../../config";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import StateManagedSelect from "react-select";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const PortfolioAdd = () => {
  const [service, setService] = useState({});
  const [segmentListOption, setSegmentList] = useState([]);
  const [assetClassList, setAssetClassList] = useState([]);
  const [editorContent, setEditorContent] = useState("");
  const [ratinaleEditorContent, setRationaleEditor] = useState("");
  const [webSiteEditorContent, setWebSiteEditorContent] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isWeightageValid, setIsWeightageValid] = useState(false);
  const [symbolList, setSymbolList] = useState([]);

  // State for dynamic dropdown lists
  const [dropdownData, setDropdownData] = useState({
    rebalance_frequencyList: [],
    constituentsList: [],
    investmentHorizonList: [],
    priceTypeList: [],
    callTypeList: [],
    instrumentsList: [],
    volatilityList: [],
    benchmarkList: []
  });

  const serviceApiOptions = [
    { value: "Intraday", label: "Intraday" },
    { value: "Single Stock", label: "Single Stock" },
    { value: "Derivative", label: "Derivative" },
  ];

  const [formValues, setFormValues] = useState({
    segid: "",
    service_name: "",
    service_api: "",
    philosophy_name: "",
    rebalance_frequency: "",
    is_free: false,
    service_description: "",
    activate: false,
    serviceSub: [],
    portfolio: [],
    investment_horizon: "",
    percentage: "",
    price_type: "",
    stock_horizon: "",
    call_type: "",
    instruments: "",
    asset_class: "",
    volatility: "",
    portfolio_image: "",
    constituents: "",
    min_investment: "",
    cagr: "",
    launch_date: "",
    blog_url: "",
    last_rebalance_date: "",
    next_rebalance_date: "",
    service_banner: "",
    rationale_file: "",
    benchmark: "",
  });

  // State for existing file URLs
  const [existingFiles, setExistingFiles] = useState({
    portfolio_image: "",
    service_banner: "",
    rationale_file: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchSymbols = async () => {
    const controller = new AbortController(); // ✅ define controller outside try so cleanup works
    try {
      const token = localStorage.getItem("authToken");
      const params = new URLSearchParams({ limit: 100 });
      const url = `${API_URL}notification/symbol?${params.toString()}`;

      // ✅ proper axios GET with abort signal
      const resp = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      });

      const rows = resp?.data?.data?.data || [];
      const nseSymbols = rows
        .filter((r) => r.exchange === "NSE")
        .map((r) => r.syms)
        .filter(Boolean);

      setSymbolList(nseSymbols);
    } catch (e) {
      if (e.name !== "CanceledError") {
        console.error("Failed to fetch symbols", e);
      }
    }

    // ✅ return cleanup function to cancel request if component unmounts
    return () => controller.abort();
  };

  // Fetch stock price from backendApi/get-price API (POST like edit.jsx)
  const fetchStockPrice = async (symbol) => {
    if (!symbol) return "0";

    try {
      const response = await axios.post(
        `${API_URL}backendApi/get-price`,
        {
          exchange: "NSE",
          symbol: symbol,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { last_price } = response.data;
      return last_price || "0";
    } catch (err) {
      console.error("Error fetching stock price:", err);
      return "0";
    }
  };

  // Fetch all dropdown data from the API
  const fetchDropdownData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}portfolio`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        const data = response.data.data;

        // Set segments (Portfolio Type) - filter for type 1 as per your existing logic
        const formattedSegments = data.segments
          .filter((dt) => dt.type == 1)
          .map((dt) => ({
            value: dt.id,
            label: dt.segmentName,
          }));

        setSegmentList(formattedSegments);

        console.log("data", data);

        setDropdownData({
          rebalance_frequencyList: data.rebalance_frequencyList || [],
          constituentsList: data.constituentsList || [],
          investmentHorizonList: data.investmentHorizonList || [],
          priceTypeList: data.priceTypeList || [],
          callTypeList: data.callTypeList || [],
          instrumentsList: data.instrumentsList || [],
          volatilityList: data.volatilityList || [],
          benchmarkList: data.benchmarklist || []
        });

        console.log("Dropdown Data", dropdownData);
      }
    } catch (error) {
      setError(error.message);
      console.error("Error fetching dropdown data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAssetClasses = async () => {
    try {
      const response = await axios.get(
        `${API_URL}notification/dropdown/asset-class`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setAssetClassList(response.data);
      }
    } catch (error) {
      console.error("Error fetching asset classes:", error);
    }
  };

  const fetchServices = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}service/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setService(response.data.data);
      setIsEditing(true);

      // Set existing file URLs
      const serviceData = response.data.data.service;
      if (serviceData) {
        const files = {
          portfolio_image: serviceData.service_image || "",
          service_banner: serviceData.service_banner || "",
          rationale_file: serviceData.rationale_file || ""
        };
        setExistingFiles(files);

        // Set existing banner filename/url if present
        if (serviceData.service_banner) {
          setFormValues((prev) => ({ ...prev, service_banner: serviceData.service_banner }));
        }

        // Set rationale file if present
        if (serviceData.rationale_file) {
          setFormValues((prev) => ({ ...prev, rationale_file: serviceData.rationale_file }));
        }
      }

      // Set asset class list from API response
      if (response.data.data.assetClassList) {
        const formattedAssetClasses = response.data.data.assetClassList.map(
          (asset) => ({
            value: asset.id,
            label: asset.asset_name,
          })
        );
        setAssetClassList(formattedAssetClasses);
      }

      // Set form values directly when service data is fetched
      if (serviceData) {
        setFormValues((prevValues) => ({
          ...prevValues,
          segid: serviceData.segid ? String(serviceData.segid) : "",
          service_name: serviceData.service_name || "",
          service_api: serviceData.service_api || "",
          philosophy_name: serviceData.philosophy_name || "",
          rebalance_frequency: serviceData.rebalance_frequency || "",
          is_free: serviceData.is_free === 1,
          service_description: serviceData.service_description || "",
          activate: serviceData.activate === 1,
          investment_horizon: serviceData.investment_period || "",
          percentage: serviceData.percentage !== undefined && serviceData.percentage !== null ? serviceData.percentage : "",
          price_type: serviceData.price_type || "",
          stock_horizon: serviceData.stock_horizon !== undefined && serviceData.stock_horizon !== null ? serviceData.stock_horizon : "",
          call_type: serviceData.call_type || "",
          instruments: serviceData.instruments || "",
          asset_class: serviceData.asset_class || "",
          volatility: serviceData.volatility || "",
          min_investment: serviceData.min_investment || "",
          cagr: serviceData.cagr || "",
          launch_date: serviceData.launch_date || "",
          blog_url: serviceData.blog_url || "",
          last_rebalance_date: serviceData.last_rebalance_date || "",
          next_rebalance_date: serviceData.next_rebalance_date || "",
          constituents: serviceData.constituents || "",
          benchmark: serviceData.benchmark || "",
        }));

        if (serviceData.description) {
          setEditorContent(serviceData.description);
        }
        if (serviceData.rationale_desc) {
          setRationaleEditor(serviceData.rationale_desc);
        }
        if (serviceData.description2) {
          setWebSiteEditorContent(serviceData.description2);
        }
      }

      // Set serviceSub and portfolios
      if (response.data.data.serviceSub) {
        const serviceSubWithCalculations = response.data.data.serviceSub.map(
          (sub) => {
            const credits = parseInt(sub.credits) || 0;
            const credits_price = parseFloat(sub.credits_price) || 0;
            const discount_price = parseFloat(sub.discount_price) || 0;

            const per_month =
              credits > 0 ? (credits_price / credits).toFixed(2) : "0.00";
            const disc_per_month =
              credits > 0 ? (discount_price / credits).toFixed(2) : "0.00";

            return {
              ...sub,
              per_month: sub.access_price_monthly || "0.00",
              disc_per_month: sub.discount_price_monthly
                ? sub.discount_price_monthly.toString()
                : "0.00",
              discount_code: sub.discount_code || "",
            };
          }
        );

        setFormValues((prevValues) => ({
          ...prevValues,
          serviceSub: serviceSubWithCalculations,
        }));
      }

      if (response.data.data.portfolios) {
        const formattedPortfolios = response.data.data.portfolios.map(
          (port) => {
            const assetClass = response.data.data.assetClassList.find(
              (ac) => ac.id === port.asset_class
            );

            return {
              id: port.id,
              stocks: port.stocks || "",
              price: port.price || "",
              weightage: port.weightage || "",
              portfolio_segment: port.portfolio_segment || "",
              asset_class: assetClass ? assetClass.id : "",
              asset_class_label: assetClass ? assetClass.asset_name : "",
            };
          }
        );

        setFormValues((prevValues) => ({
          ...prevValues,
          portfolio: formattedPortfolios,
        }));
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBannerChange = (e) => {
    const { files } = e.target;
    if (files && files[0]) {
      setFormValues((prevValues) => ({
        ...prevValues,
        service_banner: files[0],
      }));
      // Clear existing banner URL when new file is selected
      setExistingFiles(prev => ({ ...prev, service_banner: "" }));
    }
  };

  const calculateTotalWeightage = (portfolio) => {
    return portfolio.reduce((sum, port) => {
      return sum + (parseFloat(port.weightage) || 0);
    }, 0);
  };

  // Add this useEffect after your existing useEffects
  useEffect(() => {
    // In edit mode, always enable submit button regardless of weightage
    if (isEditing) {
      setIsWeightageValid(true);
    }
  }, [isEditing]);

  useEffect(() => {
    fetchDropdownData(); // Fetch all dropdown data
    fetchAssetClasses();
    fetchSymbols();
    if (id) {
      fetchServices(id);
    } else {
      setIsEditing(false);
    }
  }, [id]);

  // Handle stock selection and auto-fetch price
  const handleStockSelect = async (selectedOption, portfolioId) => {
    const symbol = selectedOption ? selectedOption.value : "";

    if (portfolioId) {
      // Update specific portfolio item
      setFormValues((prevValues) => {
        const updatedPortfolio = prevValues.portfolio.map((port) =>
          port.id === portfolioId ? { ...port, stocks: symbol } : port
        );

        return {
          ...prevValues,
          portfolio: updatedPortfolio,
        };
      });

      // Fetch and update price for the selected stock
      if (symbol) {
        const price = await fetchStockPrice(symbol);
        setFormValues((prevValues) => {
          const updatedPortfolio = prevValues.portfolio.map((port) =>
            port.id === portfolioId ? { ...port, price: price } : port
          );

          return {
            ...prevValues,
            portfolio: updatedPortfolio,
          };
        });
      }
    }
  };

  const handleEditorChange = (value) => {
    setEditorContent(value);
  };

  const handleRationaleEditorChange = (value) => {
    setRationaleEditor(value);
  };

  const handleWebsiteEditorChange = (value) => {
    setWebSiteEditorContent(value);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      segid: selectedValue,
    }));
  };

  const handleRebalanceFrequencyChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      rebalance_frequency: selectedValue,
    }));
  };

  const handleInvestmentHorizonChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      investment_horizon: selectedValue,
    }));
  };

  const handleVolatilityChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      volatility: selectedValue,
    }));
  };

  const handleBenchmarkChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      benchmark: selectedValue,
    }));
  };

  useEffect(() => {
    console.log("Current symbolList:", symbolList);
  }, [symbolList]);

  const handleConstituentsChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    setFormValues((prevValues) => ({
      ...prevValues,
      constituents: selectedValue,
    }));
  };

  // Function to calculate per month values
  const calculatePerMonthValues = (credits, credits_price, discount_price) => {
    const creditsNum = parseInt(credits) || 0;
    const creditsPriceNum = parseFloat(credits_price) || 0;
    const discountPriceNum = parseFloat(discount_price) || 0;

    const per_month =
      creditsNum > 0 ? (creditsPriceNum / creditsNum).toFixed(2) : "0.00";
    const disc_per_month =
      creditsNum > 0 ? (discountPriceNum / creditsNum).toFixed(2) : "0.00";

    return { per_month, disc_per_month };
  };

  const handleSubServiceInputChange = (e, id) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => {
      const updatedServiceSub = prevValues.serviceSub.map((subService) => {
        if (subService.id === id) {
          const updatedSub = { ...subService, [name]: value };

          // Recalculate per_month and disc_per_month when credits, credits_price, or discount_price changes
          if (
            name === "credits" ||
            name === "credits_price" ||
            name === "discount_price"
          ) {
            const { per_month, disc_per_month } = calculatePerMonthValues(
              updatedSub.credits,
              updatedSub.credits_price,
              updatedSub.discount_price
            );
            updatedSub.per_month = per_month;
            updatedSub.disc_per_month = disc_per_month;
          }

          return updatedSub;
        }
        return subService;
      });

      return {
        ...prevValues,
        serviceSub: updatedServiceSub,
      };
    });
  };

  const handlePortfolioInputChange = (e, id) => {
    if (!isEditing) {
      const { name, value } = e.target;
      setFormValues((prevValues) => {
        const updatedPortfolio = prevValues.portfolio.map((port) =>
          port.id === id ? { ...port, [name]: value } : port
        );

        // Calculate total weightage when weightage field is updated
        if (name === "weightage") {
          const totalWeightage = calculateTotalWeightage(updatedPortfolio);
          const roundedTotal = Math.round(totalWeightage * 100) / 100;
          setIsWeightageValid(roundedTotal >= 100);
        }

        return {
          ...prevValues,
          portfolio: updatedPortfolio,
        };
      });
    }
  };

  const handlePortfolioSelectChange = (e, id) => {
    if (!isEditing) {
      const { name, value } = e.target;
      setFormValues((prevValues) => ({
        ...prevValues,
        portfolio: prevValues.portfolio.map((port) =>
          port.id === id ? { ...port, [name]: value } : port
        ),
      }));
    }
  };

  const handleSubServiceSelectChange = (e, id) => {
    const selectedValue = e.target.value;
    setFormValues((prevValues) => {
      const updatedServiceSub = prevValues.serviceSub.map((subService) => {
        if (subService.id === id) {
          const updatedSub = { ...subService, credits: selectedValue };

          // Recalculate per_month and disc_per_month when credits changes
          const { per_month, disc_per_month } = calculatePerMonthValues(
            updatedSub.credits,
            updatedSub.credits_price,
            updatedSub.discount_price
          );
          updatedSub.per_month = per_month;
          updatedSub.disc_per_month = disc_per_month;

          return updatedSub;
        }
        return subService;
      });

      return {
        ...prevValues,
        serviceSub: updatedServiceSub,
      };
    });
  };

  const handleSubServiceCheckboxChange = (e, id) => {
    const { name, checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceSub: prevValues.serviceSub.map((subService) =>
        subService.id === id
          ? { ...subService, [name]: checked ? 1 : 0 }
          : subService
      ),
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: checked,
    }));
  };

  const addSubService = (type) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      serviceSub: [
        ...prevValues.serviceSub,
        {
          id: Date.now(),
          credits: type === "credits" ? "" : null,
          credits_price: "",
          discount_price: "",
          discount_code: "",
          productid: "",
          freepaid: 0,
          device_type: 0,
          stype: type === "credits" ? 0 : 1,
          per_month: "0.00",
          disc_per_month: "0.00",
        },
      ],
    }));
  };

  const addPortfolio = () => {
    if (!isEditing) {
      setFormValues((prevValues) => {
        const newPortfolio = [
          ...prevValues.portfolio,
          {
            id: Date.now(),
            stocks: "",
            price: "",
            weightage: "",
            portfolio_segment: "",
            asset_class: "",
          },
        ];

        // Disable submit button when adding a new portfolio item
        setIsWeightageValid(false);

        return {
          ...prevValues,
          portfolio: newPortfolio,
        };
      });
    }
  };

  const deleteSubService = (id) => {
    setFormValues((prevValues) => {
      // Find the sub-service to be deleted
      const updatedSubServices = prevValues.serviceSub.map((subService) => {
        if (subService.id === id) {
          // Set credits to 0 and mark as deleted for UI
          return {
            ...subService,
            credits: 0,
            credits_price: 0,
            discount_price: 0,
            discount_code: "",
            isDeleted: true, // Mark as deleted to hide from UI
          };
        }
        return subService;
      });

      return {
        ...prevValues,
        serviceSub: updatedSubServices,
      };
    });
  };

  const deletePortfolio = (id) => {
    if (!isEditing) {
      setFormValues((prevValues) => ({
        ...prevValues,
        portfolio: prevValues.portfolio.filter((port) => port.id !== id),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Create FormData for multipart/form-data
    const formData = new FormData();

    // Basic service data - matching backend DTO
    formData.append("id", id || "0");
    formData.append("segid", formValues.segid || "1");
    formData.append("service_name", formValues.service_name || "");
    formData.append("service_api", formValues.service_api || "");
    formData.append("philosophy_name", formValues.philosophy_name || "");
    formData.append(
      "service_description",
      formValues.service_description || ""
    );
    formData.append("description", editorContent || "");
    formData.append("description2", webSiteEditorContent || "");
    formData.append("buy_comment", "");
    formData.append("sell_comment", "");
    formData.append("buy_call", "");
    formData.append("sell_call", "");
    formData.append("activate", formValues.activate ? "1" : "0");
    formData.append("qty_min", "0");
    formData.append("mincap", formValues.min_investment || "0");
    formData.append("tradetype", "");
    formData.append("traderisk", "");
    formData.append("tradereturn", "");
    formData.append("current_nav", "0");
    formData.append("volatility", formValues.volatility || "");
    formData.append("lot_alloc", "true");
    formData.append("is_free", formValues.is_free ? "1" : "0");
    formData.append("check_nse", "true");
    formData.append("check_bse", "true");
    formData.append("check_mcx", "true");
    formData.append("check_nfo", "true");
    formData.append("check_bfo", "true");
    formData.append("activecount", "0");
    formData.append("rationale_desc", ratinaleEditorContent || "");
    formData.append("publish_performance", "true");
    formData.append(
      "rebalance_frequency",
      formValues.rebalance_frequency || ""
    );
    formData.append("investment_period", formValues.investment_horizon || "");
    formData.append("percentage", formValues.percentage !== "" ? String(formValues.percentage) : "0");
    formData.append("price_type", formValues.price_type || "");
    formData.append("stock_horizon", formValues.stock_horizon !== "" ? String(formValues.stock_horizon) : "0");
    formData.append("call_type", formValues.call_type || "");
    formData.append("instruments", formValues.instruments || "");
    formData.append("asset_class", formValues.asset_class || "0");
    formData.append("blog_url", formValues.blog_url || "");
    formData.append("service_type", "1");
    formData.append("portfolio_type", formValues.segid);
    formData.append("constituents", formValues.constituents || "");
    formData.append("benchmark", formValues.benchmark || "");

    // Portfolio data arrays - send as separate fields with indexes
    formValues.portfolio.forEach((port, index) => {
      formData.append(`stocks[${index}]`, port.stocks || "");
      formData.append(`weightage[${index}]`, port.weightage || "0");
      formData.append(`segment[${index}]`, port.portfolio_segment || "");
      formData.append(`asset_class_sub[${index}]`, port.asset_class || "0");
      formData.append(`price[${index}]`, port.price || "0");
      formData.append(`portfoliosubid[${index}]`, "");
    });

    // Add empty arrays for delete operations
    formData.append("portfoliosub_deleteid", "");
    formData.append("portfoliosub_delete_reason", "");
    formData.append("add_reason", "");

    // Add sub_services as JSON string - matching backend format
    const subServices = formValues.serviceSub.map((sub) => {
      // Check if id belongs to an existing sub-service or is a newly generated one (timestamp)
      const isExistingId =
        sub.id && Number.isInteger(sub.id) && sub.id < 1000000;

      if (isExistingId) {
        return {
          id: sub.id,
          credits: sub.credits,
          credits_price: sub.credits_price,
          discount_price: sub.discount_price,
          discount_code: sub.discount_code || "",
          productid: sub.productid,
          freepaid: sub.freepaid,
          device_type: sub.device_type,
          stype: sub.stype,
        };
      } else {
        // For new sub-services, return all fields except id and calculated fields
        const { id, per_month, disc_per_month, ...rest } = sub;
        return { ...rest };
      }
    });
    formData.append("sub_services", JSON.stringify(subServices));

    // Add files if they exist
    if (formValues.portfolio_image) {
      formData.append("service_image", formValues.portfolio_image);
    }

    // Add rationale file if exists
    if (formValues.rationale_file) {
      formData.append("rationale_file", formValues.rationale_file);
    } else {
      formData.append("rationale_file", "");
    }
    // Add service banner (backend expects key: service_banner)
    if (formValues.service_banner instanceof File) {
      formData.append("service_banner", formValues.service_banner);
    } else {
      // send existing banner value (filename/url) or empty string
      formData.append("service_banner", formValues.service_banner || "");
    }

    try {
      setLoading(true);
      const url = `${API_URL}portfolio/save-service`;
      console.log("Sending form data to:", url);

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("API Response:", response);

      if (response.data.success === true) {
        showToast.success(response.data.message);
        navigate("/research/Portfolio");
      } else {
        showToast.error(
          response.data.message || "There was an error saving the portfolio"
        );
      }
    } catch (error) {
      console.error("Error saving portfolio:", error);
      if (error.response) {
        console.error("Error response:", error.response.data);
        showToast.error(
          error.response.data.message ||
          "There was an error saving the portfolio"
        );
      } else {
        showToast.error("Network error occurred while saving the portfolio");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: files[0],
      }));
      // Clear existing file URL when new file is selected
      setExistingFiles(prev => ({ ...prev, [name]: "" }));
    }
  };

  const handleRationaleFileChange = (e) => {
    const { files } = e.target;
    if (files && files[0]) {
      setFormValues((prevValues) => ({
        ...prevValues,
        rationale_file: files[0],
      }));
      // Clear existing rationale file URL when new file is selected
      setExistingFiles(prev => ({ ...prev, rationale_file: "" }));
    }
  };

  // Function to view file in new tab
  const viewFile = (fileUrl, fileName) => {
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    } else {
      showToast.error(`No ${fileName} available to view`);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
      <div>
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0 mb-1">
            <span className="panel-title">
              {id ? "Edit " : "Add "}Portfolio Based Service
            </span>
          </div>
          <hr></hr>
          <form onSubmit={handleSubmit}>
            <div className="panel-body">
              <div className="row">
                {/* Portfolio Type Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="portfolio_type">Portfolio Type</label>
                  <StateManagedSelect
                    options={segmentListOption}
                    onChange={handleSelectChange}
                    value={
                      formValues.segid
                        ? segmentListOption.find(
                          (option) =>
                            option.value.toString() ===
                            formValues.segid.toString()
                        )
                        : null
                    }
                    placeholder="Select Portfolio Type"
                  />
                </div>
                {/* Service Name */}
                <div className="col-md-3">
                  <InputBox
                    label="Name of the Portfolio"
                    fieldname="service_name"
                    placeholder="Enter Portfolio/Service Name"
                    value={formValues.service_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <InputBox
                    label="Philosophy Name"
                    fieldname="philosophy_name"
                    placeholder="Enter Philosophy Name"
                    value={formValues.philosophy_name}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Investment Horizon Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="">Investment Horizon</label>
                  <StateManagedSelect
                    options={dropdownData.investmentHorizonList}
                    value={
                      formValues.investment_horizon
                        ? dropdownData.investmentHorizonList.find(
                          (option) =>
                            option.value === formValues.investment_horizon
                        )
                        : null
                    }
                    onChange={handleInvestmentHorizonChange}
                    placeholder="Select Investment Horizon"
                  />
                </div>

                {/* Rebalance Frequency Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="">Rebalance Frequency</label>
                  <StateManagedSelect
                    options={dropdownData.rebalance_frequencyList}
                    onChange={handleRebalanceFrequencyChange}
                    value={
                      formValues.rebalance_frequency
                        ? dropdownData.rebalance_frequencyList.find(
                          (option) =>
                            option.value === formValues.rebalance_frequency
                        )
                        : null
                    }
                    placeholder="Select Rebalance Frequency"
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-3">
                  <label htmlFor="">Asset Class</label>
                  <StateManagedSelect
                    options={assetClassList}
                    value={
                      formValues.asset_class
                        ? assetClassList.find(
                          (option) => option.value === formValues.asset_class
                        )
                        : null
                    }
                    onChange={(selected) =>
                      setFormValues((prev) => ({
                        ...prev,
                        asset_class: selected ? selected.value : "",
                      }))
                    }
                    placeholder="Select Asset Class"
                  />
                </div>

                {/* Volatility Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="">Volatility</label>
                  <StateManagedSelect
                    options={dropdownData.volatilityList}
                    value={
                      formValues.volatility
                        ? dropdownData.volatilityList.find(
                          (option) => option.value === formValues.volatility
                        )
                        : null
                    }
                    onChange={handleVolatilityChange}
                    placeholder="Select Volatility"
                  />
                </div>

                <div className="col-md-3">
                  <InputBox
                    label="Last Rebalance Date"
                    fieldname="last_rebalance_date"
                    placeholder="Enter Last Rebalance Date"
                    value={formValues.last_rebalance_date}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="col-md-3">
                  <InputBox
                    label="Next Rebalance Date"
                    fieldname="next_rebalance_date"
                    placeholder="Enter Next Rebalance Date"
                    value={formValues.next_rebalance_date}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="col-md-3">
                  <InputBox
                    label="Minimum Investment"
                    fieldname="min_investment"
                    placeholder="Enter Minimum Investment"
                    value={formValues.min_investment}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="col-md-3">
                  <InputBox
                    label="CAGR"
                    fieldname="cagr"
                    placeholder="Enter CAGR"
                    value={formValues.cagr}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="col-md-3">
                  <DatePicker
                    label="Launch Date"
                    fieldname="launch_date"
                    placeholder="Enter Launch Date"
                    value={formValues.launch_date || ""}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                </div>
                <div className="col-md-3">
                  <InputBox
                    label="Blog URL"
                    fieldname="blog_url"
                    placeholder="Enter Blog URL"
                    value={formValues.blog_url || ""}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Constituents Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="">Constituents</label>
                  <StateManagedSelect
                    options={dropdownData.constituentsList}
                    value={
                      formValues.constituents
                        ? dropdownData.constituentsList.find(
                          (option) => option.value === formValues.constituents
                        )
                        : null
                    }
                    onChange={handleConstituentsChange}
                    placeholder="Select Constituents"
                  />
                </div>

                {/* Portfolio Benchmark Dropdown */}
                <div className="col-md-3">
                  <label htmlFor="benchmark">Portfolio Benchmark</label>
                  <StateManagedSelect
                    options={dropdownData.benchmarkList}
                    value={
                      formValues.benchmark
                        ? dropdownData.benchmarkList.find(
                          (option) => option.value === formValues.benchmark
                        )
                        : null
                    }
                    onChange={handleBenchmarkChange}
                    placeholder="Select Portfolio Benchmark"
                  />
                </div>

                <div className="col-md-4">
                  <CheckBox
                    label="Service Access Is Free"
                    fieldname="is_free"
                    checked={formValues.is_free}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>

              <div className="row">
                {/* Portfolio Image */}
                <div className="col-md-4">
                  <label>Portfolio Image</label>
                  <div className="d-flex align-items-center">
                    <input
                      type="file"
                      name="portfolio_image"
                      onChange={handleFileChange}
                      className="form-control"
                      accept="image/*"
                    />
                    {existingFiles.portfolio_image && (
                      <button
                        type="button"
                        className="btn btn-info btn-sm ms-2"
                        onClick={() => viewFile(existingFiles.portfolio_image, "Portfolio Image")}
                        title="View Portfolio Image"
                      >
                        View
                      </button>
                    )}
                  </div>
                </div>

                {/* Portfolio Banner */}
                <div className="col-md-4">
                  <label>Portfolio Banner</label>
                  <div className="d-flex align-items-center">
                    <input
                      type="file"
                      name="service_banner"
                      onChange={handleBannerChange}
                      className="form-control"
                      accept="*/*"
                    />
                    {existingFiles.service_banner && (
                      <button
                        type="button"
                        className="btn btn-info btn-sm ms-2"
                        onClick={() => viewFile(existingFiles.service_banner, "Portfolio Banner")}
                        title="View Portfolio Banner"
                      >
                        View
                      </button>
                    )}
                  </div>
                </div>

                {/* Rationale File */}
                <div className="col-md-4">
                  <label>Rationale File</label>
                  <div className="d-flex align-items-center">
                    <input
                      type="file"
                      name="rationale_file"
                      onChange={handleRationaleFileChange}
                      className="form-control"
                      accept="*/*"
                    />
                    {existingFiles.rationale_file && (
                      <button
                        type="button"
                        className="btn btn-info btn-sm ms-2"
                        onClick={() => viewFile(existingFiles.rationale_file, "Rationale File")}
                        title="View Rationale File"
                      >
                        View
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Description */}
                <div className="col-md-12">
                  <TextAreaBox
                    label="Short Description"
                    fieldname="service_description"
                    placeholder="Enter Short Description"
                    value={formValues.service_description}
                    onChange={handleInputChange}
                  />
                </div>
                {/* Description */}
                <div className="col-md-12">
                  <label htmlFor="">Description</label>
                  <textarea
                    className="form-control"
                    rows="6"
                    value={editorContent}
                    onChange={(e) => handleEditorChange(e.target.value)}
                    placeholder="Enter description..."
                  ></textarea>
                </div>
                {/* Rationale Description 
                <div className="col-md-12 mt-3">
                  <label htmlFor="">Rationale Description</label>
                  <ReactQuill
                    value={ratinaleEditorContent}
                    onChange={handleRationaleEditorChange}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>
                {/* Website Description 
                <div className="col-md-12 mt-3">
                  <label htmlFor="">Website Description</label>
                  <ReactQuill
                    value={webSiteEditorContent}
                    onChange={handleWebsiteEditorChange}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>
                */}
              </div>
              <div className="row">
                {/* Activate and Publish Performance */}
                <div className="col-md-4">
                  <CheckBox
                    label="Set Active"
                    fieldname="activate"
                    checked={formValues.activate}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>

              {/* Carparva Fields Section */}
              {false && (
                <>
                  <div className="panel-heading border-0 mb-1 px-0 mt-3">
                    <span className="panel-title">Carparva Fields</span>
                  </div>
                  <hr />
                  <div className="row mt-3 mb-4">
                    {/* Service API Dropdown */}
                    <div className="col-md-3">
                      <label className="form-label">Service API</label>
                      <StateManagedSelect
                        options={serviceApiOptions}
                        onChange={(selected) =>
                          setFormValues((prev) => ({
                            ...prev,
                            service_api: selected ? selected.value : "",
                          }))
                        }
                        value={
                          formValues.service_api
                            ? serviceApiOptions.find(
                                (option) => option.value === formValues.service_api
                              ) || { value: formValues.service_api, label: formValues.service_api }
                            : null
                        }
                        placeholder="Select Service API"
                        isClearable
                      />
                    </div>

                    {/* Instruments Dropdown */}
                    <div className="col-md-3">
                      <label htmlFor="">Instruments</label>
                      <StateManagedSelect
                        options={dropdownData.instrumentsList}
                        value={
                          formValues.instruments
                            ? dropdownData.instrumentsList.find(
                                (option) => option.value === formValues.instruments
                              ) || { value: formValues.instruments, label: formValues.instruments }
                            : null
                        }
                        onChange={(selected) =>
                          setFormValues((prev) => ({
                            ...prev,
                            instruments: selected ? selected.value : "",
                          }))
                        }
                        placeholder="Select Instruments"
                        isClearable
                      />
                    </div>

                    {/* Price Type Dropdown */}
                    <div className="col-md-3">
                      <label htmlFor="">Price Type</label>
                      <StateManagedSelect
                        options={dropdownData.priceTypeList}
                        value={
                          formValues.price_type
                            ? dropdownData.priceTypeList.find(
                                (option) => option.value === formValues.price_type
                              ) || { value: formValues.price_type, label: formValues.price_type }
                            : null
                        }
                        onChange={(selected) =>
                          setFormValues((prev) => ({
                            ...prev,
                            price_type: selected ? selected.value : "",
                          }))
                        }
                        placeholder="Select Price Type"
                        isClearable
                      />
                    </div>

                    {/* Percentage Decimal Field */}
                    <div className="col-md-3">
                      <InputBox
                        label="Percentage For Price Range"
                        fieldname="percentage"
                        type="number"
                        jsScript={{ step: "0.01" }}
                        placeholder="Enter Percentage"
                        value={formValues.percentage}
                        onChange={handleInputChange}
                      />
                    </div>

                    {/* Call Type Dropdown */}
                    <div className="col-md-3 mt-3">
                      <label htmlFor="">Call Type</label>
                      <StateManagedSelect
                        options={dropdownData.callTypeList}
                        value={
                          formValues.call_type
                            ? dropdownData.callTypeList.find(
                                (option) => option.value === formValues.call_type
                              ) || { value: formValues.call_type, label: formValues.call_type }
                            : null
                        }
                        onChange={(selected) =>
                          setFormValues((prev) => ({
                            ...prev,
                            call_type: selected ? selected.value : "",
                          }))
                        }
                        placeholder="Select Call Type"
                        isClearable
                      />
                    </div>

                    {/* Stock Horizon Number Field */}
                    <div className="col-md-3 mt-3">
                      <InputBox
                        label="Stock Horizon In Days"
                        fieldname="stock_horizon"
                        type="number"
                        placeholder="Enter Stock Horizon"
                        value={formValues.stock_horizon}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Sub-services table */}
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Months</th>
                      <th>Price</th>
                      <th>Per Month</th>
                      <th>Discount Price</th>
                      <th>Disc Per Month</th>
                      <th>Discount Code</th>
                      <th>Plane ID</th>
                      <th>Make Free</th>
                      <th>
                        Device Type <br />
                        (is ios)
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formValues.serviceSub
                      .filter((sub) => !sub.isDeleted) // Only show non-deleted sub-services
                      .map((sub) => (
                        <tr key={sub.id}>
                          <td>
                            {sub.stype === 1 ? (
                              <>
                                <select
                                  name="credits"
                                  onChange={(e) =>
                                    handleSubServiceSelectChange(e, sub.id)
                                  }
                                  value={sub.credits || ""}
                                >
                                  <option value="">Select Option</option>
                                  {[
                                    { value: 1, label: "1 Month" },
                                    { value: 3, label: "3 Months" },
                                    { value: 6, label: "6 Months" },
                                    { value: 12, label: "12 Months" },
                                    { value: 100, label: "Lifetime" },
                                  ].map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </>
                            ) : (
                              <input
                                type="number"
                                name="credits"
                                value={sub.credits}
                                onChange={(e) =>
                                  handleSubServiceInputChange(e, sub.id)
                                }
                                placeholder="Enter Credits"
                              />
                            )}
                          </td>
                          <td>
                            <input
                              type="number"
                              name="credits_price"
                              value={sub.credits_price}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Price"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="per_month"
                              value={sub.per_month || "0.00"}
                              className="form-control"
                              disabled
                              readOnly
                              style={{
                                backgroundColor: "#f8f9fa",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              name="discount_price"
                              value={sub.discount_price}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Discount Price"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="disc_per_month"
                              value={sub.disc_per_month || "0.00"}
                              className="form-control"
                              disabled
                              readOnly
                              style={{
                                backgroundColor: "#f8f9fa",
                                cursor: "not-allowed",
                              }}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="discount_code"
                              value={sub.discount_code || ""}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Discount Code"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              name="productid"
                              value={sub.productid}
                              onChange={(e) =>
                                handleSubServiceInputChange(e, sub.id)
                              }
                              placeholder="Enter Product Id"
                            />
                          </td>
                          <td>
                            <CheckBox
                              label=""
                              fieldname="freepaid"
                              checked={sub.freepaid === 1}
                              onChange={(e) =>
                                handleSubServiceCheckboxChange(e, sub.id)
                              }
                              id={sub.id}
                            />
                          </td>
                          <td>
                            <CheckBox
                              label=""
                              fieldname="device_type"
                              checked={sub.device_type === 1}
                              onChange={(e) =>
                                handleSubServiceCheckboxChange(e, sub.id)
                              }
                              id={sub.id}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => deleteSubService(sub.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => addSubService("monthly")}
                  >
                    Add Monthly
                  </button>
                </div>
              </div>

              {/* Portfolio Data Table */}
              <div className="mt-4">
                <h4>Portfolio Data</h4>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Stocks</th>
                        <th>Weightage (%)</th>
                        <th>Segment</th>
                        <th>Asset class</th>
                        <th>Price</th>
                        {!isEditing && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {formValues.portfolio.map((port) => (
                        <tr key={port.id}>
                          <td>
                            {isEditing ? (
                              <span>{port.stocks}</span>
                            ) : (
                              <StateManagedSelect
                                options={symbolList.map((s) => ({
                                  value: s,
                                  label: s,
                                }))}
                                value={
                                  port.stocks
                                    ? {
                                      value: port.stocks,
                                      label: port.stocks,
                                    }
                                    : null
                                }
                                onChange={(opt) => handleStockSelect(opt, port.id)}
                                placeholder="Select Stock"
                                isSearchable
                                isClearable
                              />
                            )}
                          </td>
                          <td>
                            {isEditing ? (
                              <span>{port.weightage}</span>
                            ) : (
                              <input
                                type="number"
                                name="weightage"
                                value={port.weightage}
                                onChange={(e) =>
                                  handlePortfolioInputChange(e, port.id)
                                }
                                placeholder="Enter Weightage"
                              />
                            )}
                          </td>
                          <td>
                            {isEditing ? (
                              <span>{port.portfolio_segment}</span>
                            ) : (
                              <input
                                type="text"
                                name="portfolio_segment"
                                value={port.portfolio_segment}
                                onChange={(e) =>
                                  handlePortfolioInputChange(e, port.id)
                                }
                                placeholder="Enter Portfolio Segment"
                              />
                            )}
                          </td>
                          <td>
                            {isEditing ? (
                              <span>{port.asset_class_label}</span>
                            ) : (
                              <select
                                name="asset_class"
                                value={port.asset_class}
                                onChange={(e) =>
                                  handlePortfolioSelectChange(e, port.id)
                                }
                              >
                                <option value="">Select Asset Class</option>
                                {assetClassList.map((asset) => (
                                  <option key={asset.value} value={asset.value}>
                                    {asset.label}
                                  </option>
                                ))}
                              </select>
                            )}
                          </td>

                          <td>
                            {isEditing ? (
                              <span>{port.price}</span>
                            ) : (
                              <input
                                type="number"
                                name="price"
                                value={port.price}
                                onChange={(e) =>
                                  handlePortfolioInputChange(e, port.id)
                                }
                                placeholder="Enter Price"
                              />
                            )}
                          </td>
                          {!isEditing && (
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => deletePortfolio(port.id)}
                              >
                                Delete
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Only show Add Data button when not in edit mode */}
              {!isEditing && (
                <div className="row">
                  <div className="col-md-4">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={addPortfolio}
                    >
                      Add Data
                    </button>
                  </div>
                </div>
              )}

              <div className="mt-3">
                <SubmitButton
                  pageBack="/research/Portfolio"
                  handleSubmit={handleSubmit}
                  disabled={!isEditing && !isWeightageValid}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PortfolioAdd;